import { TextInput, required } from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име"
          source="name"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={4}
        sm={6}
        xs={12}
      >
        <CustomDateInput
          label="Стартира на"
          source="opensOn"
          required={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Приключва на"
          source="closesOn"
          required={true}
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
